import { createRouter, createWebHistory } from 'vue-router'

import sportRoutes from './routes/sport'
import toolboxRoutes from './routes/toolbox'
import financeRoutes from './routes/finance'
import shapeArchitect3dRoutes from './routes/shape-architect-3d'
import plansRoutes from './routes/plans'
import bettingRoutes from './routes/betting'
import suiteRoutes from './routes/suite'
import musicRoutes from './routes/music'
import explorerRoutes from './routes/explorer'

const hostname = window.location.hostname

let routes = []
let siteTitle = 'Codifyo'
let faviconHref = '/favicon.png'

if (hostname.includes('dev.codifyo') || hostname === 'localhost') {
    routes = [...toolboxRoutes]
    siteTitle = 'Toolbox | Codifyo'
    faviconHref = '/favicon-copypaste.png' // Maybe change later
} else if (hostname.includes('finance')) {
    routes = [...financeRoutes]
    siteTitle = 'Finance | Codifyo'
    faviconHref = '/favicon-finance.png'
} else if (hostname.includes('shape-architect-3d')) {
    routes = [...shapeArchitect3dRoutes]
    siteTitle = 'ShapeArchitect3D | Codifyo'
    faviconHref = '/favicon-3d.png'
} else if (hostname.includes('plans')) {
    routes = [...plansRoutes]
    siteTitle = 'Plans | Codifyo'
    faviconHref = '/favicon-plans.png'
} else if (hostname.includes('betting')) {
    routes = [...bettingRoutes]
    siteTitle = 'Betting | Codifyo'
    faviconHref = '/favicon-sport.png' // Or custom favicon
} else if (hostname.includes('suite')) {
    routes = [...suiteRoutes]
    siteTitle = 'Suite | Codifyo'
    faviconHref = '/favicon.png'
} else if (hostname.includes('music')) {
    routes = [...musicRoutes]
    siteTitle = 'Music | Codifyo'
    faviconHref = '/favicon.png'
} else if (hostname.includes('explorer')) {
    routes = [...explorerRoutes]
    siteTitle = 'Explorer | Codifyo'
    faviconHref = '/favicon-plans.png' // Or plans favicon as standard travel icon
} else {
    routes = [...sportRoutes]
    siteTitle = 'Sport | Codifyo'
    faviconHref = '/favicon-sport.png'
}

// Apply initial branding
document.title = siteTitle
const faviconLink = document.getElementById('favicon-link')
if (faviconLink) {
    faviconLink.setAttribute('href', faviconHref)
}

const router = createRouter({
    history: createWebHistory(),
    routes,
})

// Auth guard for all subdomains
if (hostname.includes('finance') || hostname.includes('shape-architect-3d') || hostname.includes('plans') || hostname.includes('betting') || hostname.includes('suite') || hostname.includes('music') || hostname.includes('explorer') || hostname.includes('dev.codifyo') || hostname === 'localhost') {
    router.beforeEach((to, from, next) => {
        const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
        const token = localStorage.getItem('apiToken');

        if (requiresAuth && !token) {
            let loginRoute = 'finance_login'
            if (hostname.includes('shape-architect-3d')) loginRoute = 'shape_architect_3d_login'
            if (hostname.includes('plans')) loginRoute = 'plans_login'
            if (hostname.includes('betting')) loginRoute = 'betting_dashboard' 
            if (hostname.includes('suite')) loginRoute = 'suite_login' 
            if (hostname.includes('music')) loginRoute = 'music_login'
            if (hostname.includes('explorer')) loginRoute = 'explorer_login'
            if (hostname.includes('dev.codifyo') || hostname === 'localhost') loginRoute = 'toolbox_login'
            
            return next({ name: loginRoute })
        }

        // Role check for Toolbox
        if (token && to.meta.requiredRole) {
            const requiredRole = to.meta.requiredRole as string;
            const userRoles = JSON.parse(localStorage.getItem('userRoles') || '[]') as string[];

            const hasRole = userRoles.includes(requiredRole);
            const isAdmin = userRoles.includes('ROLE_ADMIN');
            const isToolAdmin = userRoles.includes('ROLE_TOOL_ADMIN');
            const isToolRole = requiredRole.startsWith('ROLE_TOOL_');

            if (!hasRole && !isAdmin && !(isToolAdmin && isToolRole)) {
                console.warn(`Access denied to ${to.path}. Missing role: ${requiredRole}`);
                return next({ name: 'toolbox_dashboard' });
            }
        }

        next()
    })
}

export default router
